import type { MenuSchema } from '../MenuSchema.js';

export const ETOY_MENU_ACTIONS = {
    addBall: 'etoy-add-ball',
    addProximityVibe: 'etoy-add-proximity-vibe',
    addOscillatingRotator: 'etoy-add-oscillating-rotator',
    clearAll: 'etoy-clear-all',
} as const;

export function createEToyMenuSchema(): MenuSchema {
    return {
        id: 'ETOY',
        title: 'EToys',
        nodes: [
            { type: 'button', id: ETOY_MENU_ACTIONS.addBall, label: 'Add Ball' },
            { type: 'button', id: ETOY_MENU_ACTIONS.addProximityVibe, label: 'Add Proximity Vibrator' },
            { type: 'button', id: ETOY_MENU_ACTIONS.addOscillatingRotator, label: 'Add Oscillating Rotator' },
            { type: 'button', id: ETOY_MENU_ACTIONS.clearAll, label: 'Clear All EToys' },
        ],
    };
}
